
<template>
    <img :src="dataUrl">
</template>

<script>
import * as jrQrcode from 'jr-qrcode'

// 二维码容错级别
const QRErrorCorrectLevel = {
  L: 1,
  M: 0,
  Q: 3,
  H: 2
}

export default {
  name: 'VftQrode',
  props: {
    url: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default: () => ({
        padding: 10, // 二维码四边空白（默认为10px）
        width: 256, // 二维码图片宽度（默认为256px）
        height: 256, // 二维码图片高度（默认为256px）
        correctLevel: QRErrorCorrectLevel.H, // 二维码容错level（默认为高）
        reverse: false, // 反色二维码，二维码颜色为上层容器的背景颜色
        background: '#ffffff', // 二维码背景颜色（默认白色）
        foreground: '#000000' // 二维码颜色（默认黑色）
      })
    }
  },
  computed: {
    dataUrl () {
      return jrQrcode.getQrBase64(this.url, this.options)
    }
  }

}
</script>
